const orderStates = [
  { Name: 'Intake', ID: 1 },
  { Name: 'Delivery', ID: 2 },
  { Name: 'Billing', ID: 3 },
  { Name: 'Collection', ID: 4 },
  { Name: 'Paid', ID: 5 },
];

export default orderStates;



// WEBPACK FOOTER //
// ./src/config/orderStates.js